<template>
  <app-framework>
    <header class="container">
      <bread-crumbs :list="[
        { name: $t('home'), link: '/' },
        { name: $t('printer_settings_form') }
      ]" />
      <h1>{{ $t('printer_settings_form') }}</h1>
    </header>
    <article class="container framework-slot">
<!--      <div v-if="printers.loading">-->
<!--        <loading-state/>-->
<!--      </div>-->
<!--      <div v-else-if="printers.error">-->
<!--        <request-error-state :try-again-handler="tryAgain" :message="$t('failed_retrieve_printers')"/>-->
<!--      </div>-->
      <form v-if="settings.node" v-on:submit.prevent="saveSettings">
        <div v-if="validationError" class="alert alert-danger" role="alert">
          {{ validationError }}
        </div>
        <form-page>
          <div class="form-row">
            <form-group class="col-12 required" :label="$t('connection')" label-for="adapter"
                        prepend-icon="network-wired" :invalid-feedback="validationErrors.adapterName">
              <select id="id" class="custom-select" v-model="settings.node.adapterName" @change="queryPrinters">
                <option key="printer-adapterName-navigatorusb"
                        value="navigatorusb">{{ $t('printer_adapter_navigatorusb') }}
                </option>
                <option key="printer-adapterName-printerws"
                        value="printerws">{{ $t('printer_adapter_printerws') }}
                </option>
              </select>
            </form-group>
            <div class="form-group col-6 required">
              <label for="id" class="form-label">{{ $t('printer') }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['fal', 'print']" />
                  </span>
                </div>
                <select id="id" :class="{'custom-select': true, 'is-invalid': validationErrors.id}" v-model="settings.node.id">
                    <option v-if="printers.loading" :value="null">{{ $t('loading') }}</option>
                    <option v-else-if="printers.error" :value="null">{{ $t('failed_retrieve_printers') }}</option>
                    <option v-else v-for="printer in printers.nodes" :key="`printer-id-${printer.id}`"
                            :value="printer.id">{{ printer.name }}
                    </option>
                </select>
                <div v-if="settings.node.adapterName === 'navigatorusb'" class="input-group-append">
                  <button type="button" class="btn btn-secondary" @click="addNewPrinter">
                      <font-awesome-icon :icon="['fal', 'plus']" />
                  </button>
                </div>
                <div v-if="validationErrors.id" class="invalid-feedback">{{ validationErrors.id }}</div>
              </div>

              <small class="form-text text-muted">{{ $t('printer_description') }}</small>
            </div>
            <form-group class="col-6 required" :label="$t('have_guillotine')" label-for="country-code"
                        prepend-icon="cut"
                        :invalid-feedback="validationErrors.cutPaper">
              <select id="cut-paper" class="custom-select" v-model="settings.node.cutPaper">
                <option :value="false">{{ $t('cut_paper_no') }}</option>
                <option :value="true">{{ $t('cut_paper_yes') }}</option>
              </select>
            </form-group>
          </div>
        </form-page>
        <footer>
          <div class="form-row">
            <div class="col-auto">
              <button class="btn btn-primary">
                {{ $t('save_button') }}
              </button>
            </div>
          </div>
        </footer>
      </form>
    </article>
  </app-framework>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";
import AppFramework from "@/components/layout/AppFramework";
import BreadCrumbs from "@/components/layout/BreadCrumbs";
import FormPage from "@/components/common/FormPage";
import FormGroup from "@/components/common/FormGroup";

export default {
  name: 'printerSettingsForm',
  i18nOptions: {namespaces: ['printer_settings', 'common', 'breadcrumbs', 'error']},
  components: {FormGroup, FormPage, BreadCrumbs, AppFramework},
  mixins: [FormMixin],
  metaInfo() {
    return {
      title: this.$t('printer_settings_form')
    }
  },
  data: () => ({
    settings: {
      node: null,
      error: null
    },
    printers: {
      nodes: null,
      loading: true,
      error: null
    }
  }),
  computed: {
    isNew: function () {
      return this.$route.params.id === "new";
    },
  },
  async mounted() {
    this.settings.node = {
      adapterName: this.$store.getters["thermalPrinter/adapterName"],
      id: this.$store.getters["thermalPrinter/id"],
      name: this.$store.getters["thermalPrinter/name"],
      cutPaper: this.$store.getters["thermalPrinter/cutPaper"],
    }
    await this.queryPrinters();
  },
  methods: {
    async tryAgain() {
      await this.queryPrinters()
    },
    async addNewPrinter() {
      this.printers.loading = true;
      try {
        const selectedDevice = await this.$store.dispatch('thermalPrinter/findNewDevice', this.settings.node.adapterName);
        this.printers.nodes = await this.$store.dispatch('thermalPrinter/list', this.settings.node.adapterName);
        this.settings.node.id = selectedDevice.id;
        this.printers.error = null;
      } catch (e) {
        this.printers.error = 'FAILED_RETRIEVE_PRINTERS'
      }
      this.printers.loading = false;
    },
    async queryPrinters() {
      this.printers.loading = true;
      try {
        this.printers.nodes = await this.$store.dispatch('thermalPrinter/list', this.settings.node.adapterName);
        this.printers.error = null;
      } catch (e) {
        this.printers.error = 'FAILED_RETRIEVE_PRINTERS'
      }
      this.printers.loading = false;
    },
    async saveSettings() {
      if (!this.checkForm()) {
        return;
      }
      this.disableForm();
      try {
        this.$store.commit('thermalPrinter/setDefault', {
          adapterName: this.settings.node.adapterName,
          id: this.settings.node.id,
          name: this.printers.nodes.find(p => p.id.toString() === this.settings.node.id.toString()).name,
          cutPaper: this.settings.node.cutPaper,
        })
        await this.$router.push('/');
      } catch (e) {
        this.activeForm();
        this.showError(e);
      }
    },
    validateForm() {
      this.validateFormMixin();
    }
  }
}
</script>
